import { render, staticRenderFns } from "./DataEdit.vue?vue&type=template&id=bb50e744&scoped=true&"
import script from "./DataEdit.vue?vue&type=script&lang=js&"
export * from "./DataEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataEdit.vue?vue&type=style&index=0&id=bb50e744&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50e744",
  null
  
)

export default component.exports